import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { getAlgoListDataCachedSelectedDay } from '../../../../stores/algos-list/getters';
import StatusPill from '../../../../components/light-weight/StatusPill';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '& .chip': {
      cursor: 'inherit',
    },
  },
}));

const CellStatus = ({ row = {} }) => {
  const history = useHistory();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  const enabled = useSelector((state) => {
    const { enabled = false } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return enabled;
  });

  const status = useSelector((state) => {
    const { status = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return status;
  });

  const handleRedirectToAlgoEdit = () => {
    history.push(`/algos/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className={classes.root} onClick={handleRedirectToAlgoEdit}>
      <StatusPill status={status} enabled={enabled} />
    </div>
  );
};

export default CellStatus;
